import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { registerServiceWorker, setupInstallPrompt } from "./lib/pwa";
import "./index.scss";

// Register service worker for PWA
registerServiceWorker({
  onSuccess: () => console.log("[PWA] Content cached for offline use"),
  onUpdate: () => console.log("[PWA] New content available, please refresh"),
  onError: (error) => console.error("[PWA] Service worker error:", error),
});

// Setup PWA install prompt
setupInstallPrompt();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
